"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** Base Module Calculations */
var baseModule = exports.baseModule = function baseModule(_ref) {
  var baseModule = _ref.baseModule;
  return baseModule;
};
var halfBaseModule = exports.halfBaseModule = function halfBaseModule(_ref2) {
  var baseModule = _ref2.baseModule;
  return baseModule * 0.5;
};
var oneAndHalfBaseModule = exports.oneAndHalfBaseModule = function oneAndHalfBaseModule(_ref3) {
  var baseModule = _ref3.baseModule;
  return baseModule * 1.5;
};
var doubleBaseModule = exports.doubleBaseModule = function doubleBaseModule(_ref4) {
  var baseModule = _ref4.baseModule;
  return baseModule * 2;
};
var twoAndHalfBaseModule = exports.twoAndHalfBaseModule = function twoAndHalfBaseModule(_ref5) {
  var baseModule = _ref5.baseModule;
  return baseModule * 2.5;
};
var tripleBaseModule = exports.tripleBaseModule = function tripleBaseModule(_ref6) {
  var baseModule = _ref6.baseModule;
  return baseModule * 3;
};

var multiplierFunctions = Object.create(null);

var bmodule = exports.bmodule = function bmodule(multiplier) {
  if (!multiplierFunctions[multiplier]) {
    multiplierFunctions[multiplier] = function (_ref7) {
      var baseModule = _ref7.baseModule;
      return baseModule * multiplier;
    };
  }

  return multiplierFunctions[multiplier];
};

/** Size parameters */
var contentWidth = exports.contentWidth = function contentWidth(_ref8) {
  var contentWidth = _ref8.contentWidth;
  return contentWidth;
};
var totalColumns = exports.totalColumns = function totalColumns(_ref9) {
  var totalColumns = _ref9.totalColumns;
  return totalColumns;
};

var radiusDefault = exports.radiusDefault = function radiusDefault(_ref10) {
  var radiusDefault = _ref10.radiusDefault;
  return radiusDefault;
};
var radiusRounded = exports.radiusRounded = function radiusRounded(_ref11) {
  var radiusRounded = _ref11.radiusRounded;
  return radiusRounded;
};

/** Breakpoints */
var breakpointXsmall = exports.breakpointXsmall = function breakpointXsmall(_ref12) {
  var breakpoints = _ref12.breakpoints;
  return breakpoints.xsmall;
};
var breakpointSmall = exports.breakpointSmall = function breakpointSmall(_ref13) {
  var breakpoints = _ref13.breakpoints;
  return breakpoints.small;
};
var breakpointMedium = exports.breakpointMedium = function breakpointMedium(_ref14) {
  var breakpoints = _ref14.breakpoints;
  return breakpoints.medium;
};
var breakpointLarge = exports.breakpointLarge = function breakpointLarge(_ref15) {
  var breakpoints = _ref15.breakpoints;
  return breakpoints.large;
};
var breakpointXlarge = exports.breakpointXlarge = function breakpointXlarge(_ref16) {
  var breakpoints = _ref16.breakpoints;
  return breakpoints.xlarge;
};
var breakpointXxlarge = exports.breakpointXxlarge = function breakpointXxlarge(_ref17) {
  var breakpoints = _ref17.breakpoints;
  return breakpoints.xxlarge;
};

/** Colors */
var colorWhite = exports.colorWhite = function colorWhite(_ref18) {
  var color = _ref18.color;
  return color.white;
};
var colorBlack = exports.colorBlack = function colorBlack(_ref19) {
  var color = _ref19.color;
  return color.black;
};
var colorTransparent = exports.colorTransparent = function colorTransparent(_ref20) {
  var color = _ref20.color;
  return color.transparent;
};

var colorMain = exports.colorMain = function colorMain(_ref21) {
  var color = _ref21.color;
  return color.main;
};
var colorMainForeground = exports.colorMainForeground = function colorMainForeground(_ref22) {
  var color = _ref22.color;
  return color.mainFgTextColor;
};
var colorSecondary = exports.colorSecondary = function colorSecondary(_ref23) {
  var color = _ref23.color;
  return color.secondary;
};
var colorSecondaryForeground = exports.colorSecondaryForeground = function colorSecondaryForeground(_ref24) {
  var color = _ref24.color;
  return color.secondaryFgTextColor;
};
var colorAlert = exports.colorAlert = function colorAlert(_ref25) {
  var color = _ref25.color;
  return color.alert;
};
var colorAlertForeground = exports.colorAlertForeground = function colorAlertForeground(_ref26) {
  var color = _ref26.color;
  return color.alertFgTextColor;
};
var colorWarning = exports.colorWarning = function colorWarning(_ref27) {
  var color = _ref27.color;
  return color.warning;
};
var colorWarningForeground = exports.colorWarningForeground = function colorWarningForeground(_ref28) {
  var color = _ref28.color;
  return color.warningFgTextColor;
};
var colorError = exports.colorError = function colorError(_ref29) {
  var color = _ref29.color;
  return color.alert;
};
var colorErrorForeground = exports.colorErrorForeground = function colorErrorForeground(_ref30) {
  var color = _ref30.color;
  return color.alertFgTextColor;
};
var colorSuccess = exports.colorSuccess = function colorSuccess(_ref31) {
  var color = _ref31.color;
  return color.success;
};
var colorSuccessForeground = exports.colorSuccessForeground = function colorSuccessForeground(_ref32) {
  var color = _ref32.color;
  return color.successFgTextColor;
};
var colorInfo = exports.colorInfo = function colorInfo(_ref33) {
  var color = _ref33.color;
  return color.info;
};
var colorInfoForeground = exports.colorInfoForeground = function colorInfoForeground(_ref34) {
  var color = _ref34.color;
  return color.infoFgTextColor;
};

var colorPaletteGrey50 = exports.colorPaletteGrey50 = function colorPaletteGrey50(_ref35) {
  var colorPaletteGrey = _ref35.colorPaletteGrey;
  return colorPaletteGrey[50];
};
var colorPaletteGrey75 = exports.colorPaletteGrey75 = function colorPaletteGrey75(_ref36) {
  var colorPaletteGrey = _ref36.colorPaletteGrey;
  return colorPaletteGrey[75];
};
var colorPaletteGrey100 = exports.colorPaletteGrey100 = function colorPaletteGrey100(_ref37) {
  var colorPaletteGrey = _ref37.colorPaletteGrey;
  return colorPaletteGrey[100];
};
var colorPaletteGrey200 = exports.colorPaletteGrey200 = function colorPaletteGrey200(_ref38) {
  var colorPaletteGrey = _ref38.colorPaletteGrey;
  return colorPaletteGrey[200];
};
var colorPaletteGrey300 = exports.colorPaletteGrey300 = function colorPaletteGrey300(_ref39) {
  var colorPaletteGrey = _ref39.colorPaletteGrey;
  return colorPaletteGrey[300];
};
var colorPaletteGrey400 = exports.colorPaletteGrey400 = function colorPaletteGrey400(_ref40) {
  var colorPaletteGrey = _ref40.colorPaletteGrey;
  return colorPaletteGrey[400];
};
var colorPaletteGrey500 = exports.colorPaletteGrey500 = function colorPaletteGrey500(_ref41) {
  var colorPaletteGrey = _ref41.colorPaletteGrey;
  return colorPaletteGrey[500];
};
var colorPaletteGrey600 = exports.colorPaletteGrey600 = function colorPaletteGrey600(_ref42) {
  var colorPaletteGrey = _ref42.colorPaletteGrey;
  return colorPaletteGrey[600];
};
var colorPaletteGrey700 = exports.colorPaletteGrey700 = function colorPaletteGrey700(_ref43) {
  var colorPaletteGrey = _ref43.colorPaletteGrey;
  return colorPaletteGrey[700];
};
var colorPaletteGrey800 = exports.colorPaletteGrey800 = function colorPaletteGrey800(_ref44) {
  var colorPaletteGrey = _ref44.colorPaletteGrey;
  return colorPaletteGrey[800];
};
var colorPaletteGrey900 = exports.colorPaletteGrey900 = function colorPaletteGrey900(_ref45) {
  var colorPaletteGrey = _ref45.colorPaletteGrey;
  return colorPaletteGrey[900];
};

var colorBorder = exports.colorBorder = function colorBorder(_ref46) {
  var colorBorder = _ref46.colorBorder;
  return colorBorder;
};
var colorAnchor = exports.colorAnchor = function colorAnchor(_ref47) {
  var colorAnchor = _ref47.colorAnchor;
  return colorAnchor;
};

var colorBrandFacebook = exports.colorBrandFacebook = function colorBrandFacebook(_ref48) {
  var colorBrand = _ref48.colorBrand;
  return colorBrand.facebook;
};
var colorBrandVkontakte = exports.colorBrandVkontakte = function colorBrandVkontakte(_ref49) {
  var colorBrand = _ref49.colorBrand;
  return colorBrand.vkontakte;
};
var colorBrandGooglePlus = exports.colorBrandGooglePlus = function colorBrandGooglePlus(_ref50) {
  var colorBrand = _ref50.colorBrand;
  return colorBrand.googlePlus;
};

/** Font */
var fontFamilySansSerif = exports.fontFamilySansSerif = function fontFamilySansSerif(_ref51) {
  var fontFamily = _ref51.fontFamily;
  return fontFamily.sansSerif;
};
var fontFamilySerif = exports.fontFamilySerif = function fontFamilySerif(_ref52) {
  var fontFamily = _ref52.fontFamily;
  return fontFamily.serif;
};
var fontFamilyMonospace = exports.fontFamilyMonospace = function fontFamilyMonospace(_ref53) {
  var fontFamily = _ref53.fontFamily;
  return fontFamily.monospace;
};

var fontWeightLight = exports.fontWeightLight = function fontWeightLight(_ref54) {
  var fontWeight = _ref54.fontWeight;
  return fontWeight.light;
};
var fontWeightNormal = exports.fontWeightNormal = function fontWeightNormal(_ref55) {
  var fontWeight = _ref55.fontWeight;
  return fontWeight.normal;
};
var fontWeightSemibold = exports.fontWeightSemibold = function fontWeightSemibold(_ref56) {
  var fontWeight = _ref56.fontWeight;
  return fontWeight.semibold;
};
var fontWeightBold = exports.fontWeightBold = function fontWeightBold(_ref57) {
  var fontWeight = _ref57.fontWeight;
  return fontWeight.bold;
};

var fontSizeXsmall = exports.fontSizeXsmall = function fontSizeXsmall(_ref58) {
  var fontSize = _ref58.fontSize;
  return fontSize[-2];
};
var fontSizeSmall = exports.fontSizeSmall = function fontSizeSmall(_ref59) {
  var fontSize = _ref59.fontSize;
  return fontSize[-1];
};
var fontSizeBody = exports.fontSizeBody = function fontSizeBody(_ref60) {
  var fontSize = _ref60.fontSize;
  return fontSize[0];
};
var fontSizeBody2 = exports.fontSizeBody2 = function fontSizeBody2(_ref61) {
  var fontSize = _ref61.fontSize;
  return fontSize[1];
};
var fontSizeTitle = exports.fontSizeTitle = function fontSizeTitle(_ref62) {
  var fontSize = _ref62.fontSize;
  return fontSize[2];
};
var fontSizeHeadline = exports.fontSizeHeadline = function fontSizeHeadline(_ref63) {
  var fontSize = _ref63.fontSize;
  return fontSize[3];
};
var fontSizeDisplay1 = exports.fontSizeDisplay1 = function fontSizeDisplay1(_ref64) {
  var fontSize = _ref64.fontSize;
  return fontSize[4];
};
var fontSizeDisplay2 = exports.fontSizeDisplay2 = function fontSizeDisplay2(_ref65) {
  var fontSize = _ref65.fontSize;
  return fontSize[5];
};
var fontSizeDisplay3 = exports.fontSizeDisplay3 = function fontSizeDisplay3(_ref66) {
  var fontSize = _ref66.fontSize;
  return fontSize[6];
};
var fontSizeDisplay4 = exports.fontSizeDisplay4 = function fontSizeDisplay4(_ref67) {
  var fontSize = _ref67.fontSize;
  return fontSize[7];
};

var fontColorLight = exports.fontColorLight = function fontColorLight(_ref68) {
  var fontColor = _ref68.fontColor;
  return fontColor.light;
};
var fontColorMedium = exports.fontColorMedium = function fontColorMedium(_ref69) {
  var fontColor = _ref69.fontColor;
  return fontColor.medium;
};

/** Other */
var directionText = exports.directionText = function directionText(_ref70) {
  var direction = _ref70.direction;
  return direction.text;
};
var directionFloat = exports.directionFloat = function directionFloat(_ref71) {
  var direction = _ref71.direction;
  return direction.float;
};

var zIndexBase = exports.zIndexBase = function zIndexBase(_ref72) {
  var zIndex = _ref72.zIndex;
  return zIndex.base;
};
var zIndexNav = exports.zIndexNav = function zIndexNav(_ref73) {
  var zIndex = _ref73.zIndex;
  return zIndex.nav;
};
var zIndexAlertMobile = exports.zIndexAlertMobile = function zIndexAlertMobile(_ref74) {
  var zIndex = _ref74.zIndex;
  return zIndex.alertMobile;
};
var zIndexDropdown = exports.zIndexDropdown = function zIndexDropdown(_ref75) {
  var zIndex = _ref75.zIndex;
  return zIndex.dropdown;
};
var zIndexOverlay = exports.zIndexOverlay = function zIndexOverlay(_ref76) {
  var zIndex = _ref76.zIndex;
  return zIndex.overlay;
};
var zIndexModal = exports.zIndexModal = function zIndexModal(_ref77) {
  var zIndex = _ref77.zIndex;
  return zIndex.modal;
};
var zIndexPopup = exports.zIndexPopup = function zIndexPopup(_ref78) {
  var zIndex = _ref78.zIndex;
  return zIndex.popup;
};
var zIndexAlertDesktop = exports.zIndexAlertDesktop = function zIndexAlertDesktop(_ref79) {
  var zIndex = _ref79.zIndex;
  return zIndex.alertDesktop;
};
var zIndexTooltip = exports.zIndexTooltip = function zIndexTooltip(_ref80) {
  var zIndex = _ref80.zIndex;
  return zIndex.tooltip;
};
var zIndexMoon = exports.zIndexMoon = function zIndexMoon(_ref81) {
  var zIndex = _ref81.zIndex;
  return zIndex.moon;
};

/** Body Settings */
var bodyBackgroundColor = exports.bodyBackgroundColor = function bodyBackgroundColor(_ref82) {
  var body = _ref82.body;
  return body.bgColor;
};
var bodyFontColor = exports.bodyFontColor = function bodyFontColor(_ref83) {
  var body = _ref83.body;
  return body.fontColor;
};
var bodyFontColorAlt = exports.bodyFontColorAlt = function bodyFontColorAlt(_ref84) {
  var body = _ref84.body;
  return body.fontColorAlt;
};
var bodyFontFamily = exports.bodyFontFamily = function bodyFontFamily(_ref85) {
  var fontFamily = _ref85.fontFamily;
  return fontFamily.sansSerif;
};
var bodyFontWeight = exports.bodyFontWeight = function bodyFontWeight(_ref86) {
  var body = _ref86.body;
  return body.fontWeight;
};
var bodyLineHeight = exports.bodyLineHeight = function bodyLineHeight(_ref87) {
  var body = _ref87.body;
  return body.lineHeight;
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-core/dist/styleHelpers.js
// module id = 632
// module chunks = 0